export default __webpack_public_path__ + "static/media/one-mint-spot.f2e8a402.png";